import { supabase } from '@/lib/supabase';
import { GetStorageLogsByProjectIdParams, GetStorageLogsByUserIdParams } from './type';

export const getStorageLogsByProjectId = async ({
  project_id,
}: GetStorageLogsByProjectIdParams) => {
  const { data, error } = await supabase
    .from('storage_log')
    .select()
    .eq('project_id', project_id)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data;
};

export const getStorageLogsByUserId = async ({
  user_id,
}: GetStorageLogsByUserIdParams) => {
  const { data, error } = await supabase
    .from('storage_log')
    .select()
    .eq('user_id', user_id)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data;
};
